import React from 'react'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { useLocation } from '@guillotinaweb/react-gmi'
import { getHost } from '../utils'

export function ProductSummary(props) {
  const Ctx = useTraversal()
  const [, navigate] = useLocation()

  return (
    <div className="panel-block">
      <p className="is-size-7 is-relative" style={{ width: '100%' }}>
        <span className="tag" style={{ position: 'absolute', right: '30px' }}>
          {props.tipo}
        </span>
        <a
          href={'?path=' + props.path + '/'}
          onClick={(ev) => navigate({ path: props.path + '/' }, true)}
        >
          {props.nombre || props.id}
        </a>
      </p>
    </div>
  )
}

const DOMAINS = {
  fr: 'vinissimus.fr',
  vinissimus: 'vinissimus.com',
  italvinus: 'italvinus.it',
}

export function ProductOpciones({ product }) {
  const gotoProd = (prod) => (ev) => {
    console.log(prod)
    const domain = getHost(DOMAINS[prod.tienda])
    window.open(
      `https://${domain}/administracion/contenidos/edicion_producto.html?id_producto=${prod.referencia}`
    )
  }

  const opciones = Object.keys(product.opciones)
    .map((opcion) => product.opciones[opcion])
    .sort((a, b) => (a.anyada > b.anyada ? -1 : 1))

  return (
    <div className="columns" style={{ marginBottom: '30px' }}>
      <div className="column " style={{ maxHeight: '200px', overflow: 'auto' }}>
        <table className="table is-striped is-size-7 is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Ref</th>
              <th>Estado</th>
              <th>Ultimas</th>
              <th>Precio</th>
              <th>P.IVA</th>
              <th>Prov</th>
              <th>Cap.</th>
              <th>Año</th>
              <th>O</th>
            </tr>
          </thead>
          <tbody>
            {opciones.map((opcion, idx) => (
              <tr key={idx}>
                <td>
                  <a onClick={gotoProd(opcion)}>
                    {opcion.tienda} / {opcion.referencia}
                  </a>
                </td>
                <td>{getEstado(opcion.estado)}</td>
                <td>{opcion.ultimas_unidades}</td>
                <td>{opcion.precio_sin_impuestos} &euro;</td>
                <td>{opcion.precio} &euro;</td>
                <td>{opcion.proveedor}</td>
                <td>{opcion.capacidad}</td>
                <td>{opcion.anyada}</td>
                <td>
                  <OfertaViewer oferta={opcion.oferta} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const ESTADOS = {
  selling: 'tag is-success',
  notavaliable: 'tag is-danger',
  new_product: 'tag is-light',
  invalid: 'tag is-warning',
}

const getEstado = (estado) => {
  return (
    <span className={ESTADOS[estado] || 'tag is-light'}>
      {estado.toUpperCase()}
    </span>
  )
}

const OFERTAS = {
  o: 'Oferta',
}

export function OfertaViewer({ oferta }) {
  if (!oferta) return null
  return (
    <React.Fragment>
      <span className="tag is-warning">
        {OFERTAS[oferta.id_tipo] || oferta.id_tipo}
      </span>
      {oferta.precio_oferta}&euro;
    </React.Fragment>
  )
}
